// extracted by mini-css-extract-plugin
export default {"address2":"display_address2__U9lbF","city":"display_city__Zg1WF"};